export const popupText = {
  globalMessage: {
    popupTitle: 'dialogue_discard_changes_title',
    popupStatusMessage: 'dialogue_discard_changes_desc',
    submitBtnText: 'yes_action',
    cancelBtnText: 'No',
  },
  siteSurfaceMessage: {
    popupTitle: 'patrolTemplate_discard_surface_title',
    popupStatusMessage: 'patrolTemplate_discard_surface_desc',
    submitBtnText: 'patrolTemplate_discard_surface_pos_button',
    cancelBtnText: 'patrolTemplate_discard_surface_neg_button',
  },
  site: {
    popupTitle: 'patrolTemplate_discard_site_title',
    popupStatusMessage: 'patrolTemplate_discard_site_desc',
    submitBtnText: 'patrolTemplate_discard_site_pos_button',
    cancelBtnText: 'patrolTemplate_discard_site_neg_button',
  },
  submitBtnText: 'yes_action',
  cancelBtnText: 'cancel',
  patrolPath: {
    popupTitle: 'patroldialog_skipevidence_title',
    popupStatusMessage: 'patroldialog_skipevidence_desc',
    submitBtnText: 'yes_action',
    cancelBtnText: 'No',
  },
  abort: {
    popupTitle: 'patroldialog_abort_title',
    popupStatusMessage: 'patroldialog_abort_desc',
    submitBtnText: 'yes_action',
    cancelBtnText: 'No',
  },
  passwordResetError: {
    popupTitle: 'Error',
    submitBtnText: 'OK',
    cancelBtnText: 'No',
  },
};
